'use client';

import { useModalDrawerContext } from '../../../common/components/ModalDrawerContext/ModalDrawerContext';
import { useIsBelowScreenWidth } from '../../../layouts/utils/useIsBelowScreenWidth';
import { ButtonBase } from '../../../common/components';
import {
  CancelOrderConfirmationDrawer,
  CancelOrderConfirmationDrawerProps,
} from '../CancelOrderConfirmationDrawer/CancelOrderConfirmationDrawer';

const CancelOrderConfirmationButton = ({
  orderId,
  translations,
}: CancelOrderConfirmationDrawerProps) => {
  const { openDrawer } = useModalDrawerContext();

  const isMobile = useIsBelowScreenWidth(1024);

  const onClickButton = () => {
    openDrawer(CancelOrderConfirmationDrawer, {
      orderId,
      translations,
      position: isMobile ? 'bottom' : 'right',
    });
  };

  return (
    <ButtonBase
      fullWidth
      size="large"
      visual="secondary"
      onClick={onClickButton}
    >
      {translations.cancelOrder}
    </ButtonBase>
  );
};

export { CancelOrderConfirmationButton };
